import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=2e684c23&scoped=true&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e684c23",
  null
  
)

export default component.exports